import styles from "./styles.module.css";

import AkbankLogo from "@/src/assets/svg/akbank-logo.svg";
import ArrowRight from "@/src/assets/svg/arrow-right.svg";

import { Ga4WithEventParameters } from "@/src/helpers/google-tag-manager/events/ga4-with-eventparameters";

const AkbankStickyBanner = () => {
  const redirectUrl =
    "https://mza5.tr.adj.st/akbankdirekt?function=609&widget=true&adj_t=1rwlspmw&adj_campaign=100k_kredi&adj_deep_link=akbankdirekt%3A%2F%2Fsplash%2Ffunction%2F609&adj_fallback=https%3A%2F%2Fwww.akbank.com%2Fbasvuru%2Fmobileappservice%2F%23&adj_redirect_macos=https%3A%2F%2Fwww.akbank.com%2Fbasvuru%2Fmobileappservice%2F%23";

  const handleBannerClick = () => {
    Ga4WithEventParameters({
      eventName: "ilan_banner",
      eventParameters: { widget: "akbank_kampanya_listeleme" },
    });
  };

  return (
    <a
      href={redirectUrl}
      target="_blank"
      rel="nofollow noreferrer"
      className={styles.akbankContainer}
      onClick={handleBannerClick}
      title="Akbank 100.000 TL Kredi Fırsatı"
    >
      <AkbankLogo />
      <div className={styles.divider}></div>
      <span className={styles.creditText}>100.000 TL Kredi Fırsatı</span>
      <div className={styles.rightIcon}>
        <ArrowRight />
      </div>
    </a>
  );
};

export default AkbankStickyBanner;
